import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToFormulateActionPlans');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now that you have considered the factors involved in formulating
                                                action plans and have some
                                                practical tips to guide you it is worth thinking about what to
                                                do next. Here are a number of
                                                suggestions to maintain momentum (although these are by no means
                                                exhaustive):</p>
                                            <div className="border_subtitle">Reflect on your approach</div>
                                            <p>Ask yourself what part of action planning you find most
                                                challenging or need most support with.
                                                Be honest with yourself to identify the positive and negative
                                                consequences of your current
                                                approach and think about what you would like to modify to
                                                improve.</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to benchmark your current performance by
                                                asking for formal or informal
                                                feedback. This can help you understand how well others perceive
                                                your action planning. You can
                                                also help others around you by managing their expectations or by
                                                modifying your approach.</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about the opportunities that you have in your current work,
                                                or elsewhere, to practise action
                                                planning. This could involve your team or colleagues, so think
                                                about how this might play out.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use the tool in this document to highlight your action planning
                                                approach. Once you have
                                                established your preferences you could put together a focused
                                                development plan to improve your
                                                effectiveness.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDevelopStrategicLongTermGoals')}
                                                        className="link_color task button-link-redirect">How to develop strategic
                                                        long-term goals</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToThinkAboutProblemsLaterally')}
                                                        className="link_color task button-link-redirect">How to think about problems
                                                        laterally</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToPrioritiseTasksReadyForAction')}
                                                        className="link_color task button-link-redirect">How to prioritise tasks
                                                        ready for action</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToTakeResponsibility')}
                                                        className="link_color task button-link-redirect">How to take
                                                        responsibility</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDelegate')}
                                                        className="link_color task button-link-redirect">How to delegate.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Doran, G. (1981).
                                                    There’s a SMART Way to Write Management Goals and
                                                    Objectives,
                                                    <span className="subtiltereg"> Management Review</span> (AMA
                                                    Forum).</p></li>
                                                <li><p className="further_info_content"> Day, T., &amp; Tosey,
                                                    P. (2011). Beyond SMART? A new framework for goal setting.
                                                    <span
                                                        className="subtiltereg">Curriculum Journal,</span> 22(4),
                                                    515-534.</p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}